(function ($) {
    $.fn.extend({
        xss: {
            sanitize: sanitize
        }
    });

    function sanitize(str) {
        var bad = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#x27;',
            '/': '&#x2F;'
        },
            sql = [
                "select", "replace", "insert", "update", "drop", "where", "from", "create", "group by", "join", "limit", "round"
            ].join("|"),
            ret = str;

        for (var k in bad) {
            if (!bad.hasOwnProperty(k)) continue;
            ret = ret.split(k).join(bad[k]);
        }
        var out = ret.replace(new RegExp(sql, 'gi'), "\"$&\"");

        return out;
    }
}(window.jQuery));

function sanitizeHtmlStrings(htmlString, options) {
    var defaultOptions = {
        whiteList: {
            div: ["class", "tabindex", "role", "id", "style"],
            h3: ["class"],
            p: ["class"],
            button: ["data-bs-toggle", "data-bs-target", "type", "class", "data-bs-dismiss", "aria-label"],
            span: ["class", "aria-hidden", "role", "aria-label", "id"],
            ul: ["class"],
            li: ["class"],
            input: ["type", "id", "name", "value", "class", "checked"],
            label: ["for"],
            i: ["class"],
            br: [],
            a: ["class", "aria-hidden", "role", "aria-label", "id", "tabindex"]
        }
    };
    var optionsToApply = options ? options : defaultOptions;
    return filterXSS(htmlString, optionsToApply);
}